import axios from "axios";
import { handleAxiosErrors, getRessource } from "../utils";

const IMMEUBLES = "/immeuble";
const GET_IMMEUBLES_FTTH_WKT = `${IMMEUBLES}/get-immeubles-ftth-wkt`;
const GET_IMMEUBLES_VN_FTTH_WKT = `${IMMEUBLES}/get-immeubles`;
const GET_IMMEUBLES_VN_FTTE_WKT = `${IMMEUBLES}/get-immeubles-ftte`;
const GET_INFOS_IMMEUBLE = `${IMMEUBLES}/get-infos-immeuble`;
const GET_INFOS_IMMEUBLE_PAR_HEXACLE = `${IMMEUBLES}/get-infos-immeuble-par-hexacle`;

export const getImmeublesFtthWkt = (minLng, minLat, maxLng, maxLat, abort) =>
  axios
    .get(GET_IMMEUBLES_FTTH_WKT, {
      params: {
        minLng,
        minLat,
        maxLng,
        maxLat,
      },
      signal: abort.signal,
    })
    .then(response => handleAxiosErrors(response))
    .then(url => getRessource(url, abort))
    .catch(error => Promise.reject(error));

export const getImmeublesVendeeFtthWkt = (minLng, minLat, maxLng, maxLat, abort) =>
  axios
    .get(GET_IMMEUBLES_VN_FTTH_WKT, {
      params: {
        minLng,
        minLat,
        maxLng,
        maxLat,
      },
      signal: abort.signal,
    })
    .then(response => handleAxiosErrors(response))
    .then(url => getRessource(url, abort))
    .catch(error => Promise.reject(error));

export const getImmeublesVendeeFtteWkt = (minLng, minLat, maxLng, maxLat, abort) =>
  axios
    .get(GET_IMMEUBLES_VN_FTTE_WKT, {
      params: {
        minLng,
        minLat,
        maxLng,
        maxLat,
      },
      signal: abort.signal,
    })
    .then(response => handleAxiosErrors(response))
    .then(url => getRessource(url, abort))
    .catch(error => Promise.reject(error));

export const getImbInfos = (refIMB, abort) =>
  axios
    .get(GET_INFOS_IMMEUBLE, {
      params: {
        refIMB,
      },
      signal: abort.signal,
    })
    .then(response => handleAxiosErrors(response))
    .then(url => getRessource(url, abort))
    .catch(error => Promise.reject(error));

export const getImbInfosByHexacle = (refHexacle, abort) =>
  axios
    .get(GET_INFOS_IMMEUBLE_PAR_HEXACLE, {
      params: {
        refHexacle,
      },
      signal: abort.signal,
    })
    .then(response => handleAxiosErrors(response))
    .then(url => getRessource(url, abort))
    .catch(error => Promise.reject(error));
